import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { noop } from 'ui-components/default-props/noop';

import { usePrintSettings } from '../../core/hooks';
import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';
import { usePackingSlip } from '../hooks/use-packing-slip';

export const PackingSlip = ({ fulfillmentPlanIds, fulfillmentPlans, packingSlipTemplateId, onClick: onClickProp = noop }) => {
  const { isDisabled, onClick, onDownload, onPrint } = usePackingSlip({
    fulfillmentPlanIds,
    fulfillmentPlans,
    packingSlipTemplateId,
  });
  const printSettings = usePrintSettings(DocumentType.PackingSlip.printSettingKey);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSettings, onPrint, onDownload),
    [onDownload, onPrint, printSettings],
  );

  const onClickMenuItem = useCallback(() => {
    onClick();
    onClickProp();
  }, [onClickProp, onClick]);

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      docType={DocumentType.PackingSlip} // EJG: This may be able to be removed
      name={DocumentType.PackingSlip.documentNameTranslation}
      onClick={onClickMenuItem}
    />
  );
};

PackingSlip.propTypes = {
  fulfillmentPlanIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  fulfillmentPlans: PropTypes.array.isRequired,
  packingSlipTemplateId: PropTypes.string,
  onClick: PropTypes.func,
};
